import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, MessageCircle, Facebook, Instagram } from 'lucide-react';
import { contactInfo } from '../data/services';
import { useServices } from '../context/ServiceContext';

export const Footer = () => {
  const { services } = useServices();
  return (
    <footer className="bg-[#001a88] text-white border-t border-blue-400/20" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
          {/* Brand Section */}
          <div className="space-y-6">
            <Link to="/" className="inline-block">
              <img
                src="/assets/white-logo.svg"
                alt={contactInfo.brandName}
                className="h-14 w-auto"
              />
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed">
              <span className="block text-white font-medium mb-1">Expert Home Services, Just a Tap Away</span>
              Trusted, affordable, and professional solutions for all your home needs delivered with care and precision.
            </p>
            {/* Social/Contact Quick */}
            <div className="flex gap-3">
              <a
                href={`https://wa.me/${contactInfo.whatsapp}`}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center transition-colors"
                data-testid="footer-whatsapp"
              >
                <MessageCircle size={18} />
              </a>
              <a
                href={`tel:+91${contactInfo.phone}`}
                className="w-10 h-10 bg-blue-500 hover:bg-blue-600 rounded-full flex items-center justify-center transition-colors"
                data-testid="footer-call"
              >
                <Phone size={18} />
              </a>
              <a
                href="https://facebook.com/vhfms"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-blue-700 hover:bg-blue-800 rounded-full flex items-center justify-center transition-colors"
                title="Facebook"
              >
                <Facebook size={18} />
              </a>
              <a
                href="https://instagram.com/vhfms"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gradient-to-tr from-yellow-400 via-red-500 to-purple-600 hover:opacity-90 rounded-full flex items-center justify-center transition-opacity"
                title="Instagram"
              >
                <Instagram size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="lg:pl-10">
            <h4 className="text-lg font-semibold mb-6 font-['Oswald']">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-slate-400 hover:text-blue-400 text-sm transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/#services" className="text-slate-400 hover:text-blue-400 text-sm transition-colors">
                  All Services
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-slate-400 hover:text-blue-400 text-sm transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-400 hover:text-blue-400 text-sm transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-6 font-['Oswald']">Our Services</h4>
            <ul className="space-y-3">
              {services.slice(0, 5).map((service) => (
                <li key={service.id}>
                  <Link
                    to={`/service/${service.id}`}
                    className="text-slate-400 hover:text-blue-400 text-sm transition-colors"
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/contact" className="text-blue-400 font-semibold hover:text-blue-300 text-sm transition-colors">
                  And More services
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal Section */}
          <div>
            <h4 className="text-lg font-semibold mb-6 font-['Oswald']">Legal</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/contact" className="text-slate-400 hover:text-blue-400 text-sm transition-colors">
                  Terms & conditions
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-400 hover:text-blue-400 text-sm transition-colors">
                  Privacy policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-6 font-['Oswald']">Cooperate Office address</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-white mt-0.5 flex-shrink-0" />
                <span className="text-slate-400 text-sm">{contactInfo.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={18} className="text-white flex-shrink-0" />
                <a
                  href={`tel:+91${contactInfo.phone}`}
                  className="text-slate-400 hover:text-blue-400 text-sm transition-colors"
                >
                  +91 {contactInfo.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={18} className="text-white flex-shrink-0" />
                <a
                  href={`mailto:${contactInfo.email}`}
                  className="text-slate-400 hover:text-blue-400 text-sm transition-colors"
                >
                  {contactInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-blue-400/20 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-500 text-sm">
              © 2025 {contactInfo.brandName}. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm">
              {/* links moved to legal section */}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
